// PeidGenerator.js - Version sans dépendance

const PEID_REG = {};
let peidSeq = 1;

// Fonction slugify maison
const simpleSlugify = (text) => {
  if (!text) return '';
  
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')           
    .replace(/[^\w\-]+/g, '')      
    .replace(/\-\-+/g, '-')         
    .replace(/^-+/, '')               
    .replace(/-+$/, '');   
};

// export const getPEID = (nom, cin) => {
//   const cinClean = (cin || '').replace(/\s/g, '').toUpperCase();
//   const nomSlug = simpleSlugify(nom || '');
  
//   // Clé utilisée pour l'indexation
//   const key = cinClean ? 'CIN:' + cinClean : (nomSlug ? 'NOM:' + nomSlug : null);
  
//   if (!key) return null;
  
//   if (!PEID_REG[key]) {
//     const n = String(peidSeq++).padStart(5, '0');
//     PEID_REG[key] = 'PE-' + n;
//   }
  
//   return PEID_REG[key];
// };

export const getPEID = (id) => {
 if(!id) return null;
 const key = String(id).trim().toUpperCase();
 
  const n = String(key).padStart(5, '0');
    const peid = 'PE-' + n;
  
  
  return peid;
};
export const getPID = (id) => {
 if(!id) return null;
 const key = String(id).trim().toUpperCase();
 
  const n = String(key).padStart(5, '0');
    const pid = 'P-' + n;
  
  
  return pid;
};

export const getSpmPID = (id) => {
  const number = String(id ?? '').trim().replace(/^SPM-/i, '');
  if (!/^\d+$/.test(number) || Number(number) <= 0) return null;
  return `SPM-${number.padStart(5, '0')}`;
};

export const resetPEID = () => {
  // Réinitialiser le cache (utile pour les tests)
  Object.keys(PEID_REG).forEach(key => delete PEID_REG[key]);
  peidSeq = 1;
};
